module.exports = __webpack_public_path__ + "img/fab_logo.b30be88c.jpeg";